import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import { siteName, siteDescription, siteKeywords, siteUrl } from '@/mocks/site';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteName,
  url: siteUrl,
  description: siteDescription,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/search?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteName,
  url: siteUrl,
  description: siteDescription,
  slogan: '让每一部日韩好片，都有中文相伴',
  foundingDate: '2018',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'contact@zhongwenzimu-rihan.com',
  },
};

export default function Home() {
  return (
    <>
      <SEO
        title={`${siteName} — ${siteDescription.slice(0, 40)}`}
        description={siteDescription}
        keywords={siteKeywords}
        canonicalUrl={siteUrl}
        ogImage="https://readdy.ai/api/search-image?query=Japanese%20Korean%20film%20TV%20subtitle%20navigation%20website%20homepage%2C%20warm%20elegant%20design%2C%20minimalist%20layout%2C%20Chinese%20subtitle%20resource%20platform&width=1200&height=630&seq=home-og&orientation=landscape"
        schema={{ ...homeSchema, ...orgSchema }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedSection />
        <LatestSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}